module.exports = __webpack_public_path__ + "static/media/freshpaint3.4aec058b.jpg";